export default __webpack_public_path__ + "img/daa33f8fc9ecc778106608e82428d6bb.svg";